<div #viewer class="apryse-viewer"></div>

@if (loaded()) {
  <app-file-preview-controls
    [canSearch]="canSearch()"
    [canZoomIn]="canZoomIn()"
    [canZoomOut]="canZoomOut()"
    [currentPage]="currentPage()"
    [pageCount]="pageCount()"
    [searchCurrent]="searchCurrent()"
    [searchTotal]="searchTotal()"
    [zoomPercent]="zoomPercent()"
    (clearSearch)="clearSearch()"
    (fit)="fitWidth()"
    (goToPage)="goToPage($event)"
    (nextMatch)="nextMatch()"
    (nextPage)="nextPage()"
    (prevMatch)="prevMatch()"
    (prevPage)="prevPage()"
    (searchSubmit)="search($event)"
    (zoomIn)="zoomIn()"
    (zoomOut)="zoomOut()"
  />
}
